export default __webpack_public_path__ + "static/media/morphle-updated-logo.a9d23cde.png";